var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingEmotionLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1043,
    height: 620,
    viewBox: "0 0 1043 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13281 615.399C95.5667 588.093 309.944 549.668 468.005 451.775C577.518 383.949 641.959 322.9 680.365 268.406M680.365 268.406C711.249 224.585 725.298 185.004 732.412 149.547C743.083 96.3624 724.68 -36.3993 638.046 16.866C562.835 63.1077 535.414 252.174 680.365 268.406ZM680.365 268.406C686.403 269.082 692.739 269.458 699.384 269.512C865.556 270.851 967.235 196.37 999.254 172.387C1024.87 153.201 1111.08 82.6507 1123.64 51.1779",
    stroke: "#C2F2EA",
    strokeWidth: 8.64,
    strokeLinecap: "round",
    strokeDasharray: "24 24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingEmotionLine);
export default __webpack_public_path__ + "static/media/LandingEmotionLine.308a1aa9608ece79e67e678e285e6197.svg";
export { ForwardRef as ReactComponent };